export enum AIGCPIPLINEAPI {
    // For example
    aigcPiplineAip = "/aigc/pipline/aip", // 12.29
    feedback = "/api/aigcpipeline/tools/feedback",
    generateOneSlide = "/api/aigcpipeline/tools/oneslide/v1.0/generate",
    changeImage = "/api/aigcpipeline/tools/oneslide/changeimage",
    login = "/api/auth",
    onlineWorkflowList = "/api/aigcpipeline/workflows/online",
    onlineWorkflowStatus = "/api/aigcpipeline/workflows/online/{workflowId}/status",
    onlineWorkflowInstance = "/api/aigcpipeline/workflows/online/{workflowId}",
    onlineWorkflowUploadFile = "/api/aigcpipeline/workflows/online/{workflowId}/{taskName}",
    onlineWorkflowTemplates = "/api/aigcpipeline/workflowtemplates/online",
    onlineWorkflow = "/api/aigcpipeline/workflows/online/{workflowTemplateName}",
    kickoffOnlineWorkflow = "/api/aigcpipeline/workflows/online/{workflowId}/kickoff",
    rerunOnlineWorkflow = "/api/aigcpipeline/workflows/online/{workflowId}/rerun/{taskName}",
    rerunOnlineWorkflowNoOverwrite = "/api/aigcpipeline/workflows/online/{workflowId}/rerun/{taskName}/nooverwrite",
    smartArtVariants = "/api/aigcpipeline/workflows/online/{workflowId}/smartart-variants",
    Substyles = "/api/aigcpipeline/workflowtemplates/online/styles/{style}/substyles",
    Styles = "/api/aigcpipeline/workflowtemplates/online/{workflowTemplateName}/styles",
    Languages = "/api/aigcpipeline/workflowtemplates/online/languages",
    Regions = "/api/aigcpipeline/workflowtemplates/online/regions",
    MjGenerationModes = "/api/aigcpipeline/workflowtemplates/online/mjGenerationModes",
    PostProcess = "/api/aigcpipeline/tools/template/postprocess",
    ReverseSlideMaster = "/api/aigcpipeline/tools/template/reverse_slidemaster",
    ImageGenerationModels = "/api/aigcpipeline/workflowtemplates/online/imageGenerationModels",
    GenerateAndAnalyzeImage = "/api/aigcpipeline/tools/generateAnalyzeImage",
    GenerateAltTextImages = "/api/aigcpipeline/tools/image/alttext/batch",
    CompressImage = "/api/aigcpipeline/tools/template/compress/{quality}",
    ChangeThemeColor = "/api/aigcpipeline/tools/template/changethemecolor",
    // Demo APIs for Clippy - following OutlineProcessor.cs structure
    demoIntentRecognition = "/api/outline/demo_intent_recognition",
    demoGenerateOutline = "/api/outline/demo_generate_outline",
    // LiveDemoV2 APIs for template plan generation
    liveDemoV2PlanRun = "/api/aigcpipeline/livedemo/v2/workflow/steps/plan/run",
    liveDemoV2PlanQuery = "/api/aigcpipeline/livedemo/v2/workflow/{workflowTemplateName}/{workflowId}/steps/plan/query",
    // Theme and Template APIs
    themeAndTemplateRun = "/api/aigcpipeline/livedemo/v2/workflow/{workflowTemplateName}/{workflowId}/steps/themeandtemplate/run",
    themeAndTemplateQuery = "/api/aigcpipeline/livedemo/v2/workflow/{workflowTemplateName}/{workflowId}/steps/themeandtemplate/query",
    // Image & Icon Management APIs
    imageList_POST = "/api/aigcpipeline/workflows/tool/library/image/query",
    imageGetUrl_GET = "/api/aigcpipeline/workflows/tool/library/image/{imageId}/urls",
    iconQuery_POST = "/api/aigcpipeline/workflows/tool/library/icon/query",
    iconGetUrl_GET = "/api/aigcpipeline/workflows/tool/library/icon/{iconId}/url",
    // imageDetail = "/api/aigcpipeline/images/{imageId}",
    imageOperationsUrl = "/api/aigcpipeline/workflows/tool/library/image",
    // imageOperationsUrl endpoint supports both POST (upload) and DELETE (delete with ?id= param)
    sessionMessages = "/api/aigcpipeline/session/online/{sessionId}/messages",
    // Decoration icon generation API (returns JSON with base64 PNG)
    decoration = "/api/decoration",
    // Decoration download API (returns binary PNG)
    decorationDownload = "/api/decoration/download",
    // Decoration batch API (returns ZIP file with multiple PNGs)
    decorationBatch = "/api/decoration/batch",
    // Decoration with style transfer from reference image (returns binary PNG)
    decorationStyleFromImage = "/api/decoration/stylefromimage",
}
